import cn from "classnames"

import { CLIENT_AUTHORIZATION_PLACE } from "../../Default/common/constant"

import styles from "./style.module.scss"

import { Img } from "ui-kit/components-branded"
import {
    PSYALTER_SUPPORT_TELEGRAM,
    PSYALTER_SUPPORT_TELEGRAM_NAME,
    PSYALTER_SUPPORT_EMAIL,
} from "utils/env-management"

export const SuccessLoginPage = ({
    email,
    place,
    className,
}: {
    email: string
    place?: CLIENT_AUTHORIZATION_PLACE
    className?: string
}) => {
    return (
        <div
            className={cn(
                styles.card,
                {
                    [styles.isMain]: place === CLIENT_AUTHORIZATION_PLACE.MAIN,
                },
                className
            )}
        >
            <div>
                <div className={styles.cardHeadline}>Войдите по&nbsp;ссылке из&nbsp;почты</div>
                <div className={styles.cardText}>
                    Мы&nbsp;отправили ссылку для входа на&nbsp;{email}
                </div>
            </div>
            <div>
                <div className={styles.cardIllustration}>
                    <Img src="success-auth-illustration.svg" alt="иллюстрация входа" />
                </div>
                <small className={styles.personalInfo}>
                    Если письмо не&nbsp;пришло, свяжитесь с&nbsp;нами в Телеграме{" "}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={PSYALTER_SUPPORT_TELEGRAM}
                        className={styles.supportLink}
                    >
                        {PSYALTER_SUPPORT_TELEGRAM_NAME}
                    </a>{" "}
                    или через почту{" "}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`mailto:${PSYALTER_SUPPORT_EMAIL}`}
                        className={styles.supportLink}
                    >
                        {PSYALTER_SUPPORT_EMAIL}
                    </a>
                    .
                </small>
            </div>
        </div>
    )
}
